import { render, staticRenderFns } from "./HospitalizationForm.vue?vue&type=template&id=4afe6598&scoped=true"
import script from "./HospitalizationForm.vue?vue&type=script&lang=js"
export * from "./HospitalizationForm.vue?vue&type=script&lang=js"
import style0 from "./HospitalizationForm.vue?vue&type=style&index=0&id=4afe6598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afe6598",
  null
  
)

export default component.exports